import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'dateTimeExtra'
})
export class DateTimeExtraPipe implements PipeTransform {
  transform(value: Date | string): string | null {
    const date = new Date(value);
    const locale = localStorage.getItem("lang") || navigator.language || 'en-US';
    const dateFormatter = new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
    const timeFormatter = new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
    const datePart = dateFormatter.format(date);
    const timePart = timeFormatter.format(date);

    return `${datePart} ${timePart.replace(':', 'h')}`;
  }
}
